<template>
  <div class>
    <STable ref="tableref" :url="url" :columns="columns" :handles="handles" :query="query" label-width="120px"
      :toolbar="toolbar" />
  </div>
</template>
<script>
export default {
  name: 'Rukoufangan',
  components: {},
  data() {
    return {
      url: '/business/entrance/page',
      columns: [
        {
          label: '方案名称',
          prop: 'name'
        },
        {
          label: '提供运营商',
          prop: 'operatorOrgName'
        },
        // {
        //     label: "电费原价（元）",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        // {
        //     label: "服务费原价（元）",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        // {
        //     label: "电费优惠价（元）",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        // {
        //     label: "服务费优惠价（元）",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        // {
        //     label: "电费活动价",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        // {
        //     label: "服务费活动价",
        //     prop: "",
        //     template:function(index,record){
        //         return "--"
        //     }
        // },
        {
          label: '电费优惠类型',
          prop: 'electricityType',
          template: function (index, record) {
            return record.electricityType == 'fixed' ? '电费一口价' : '电费折扣'
          }
        },
        {
          label: '电费折扣',
          prop: 'electricity',
          template: function (index, record) {
            if (record.electricityType == 'fixed') {
              return record.electricity + '元'
            } else {
              return record.electricity + '%'
            }
          }
        },
        {
          label: '服务费优惠类型',
          prop: 'serviceFeeType',
          template: function (index, record) {
            return record.serviceFeeType == 'fixed' ? '服务费一口价' : '服务费折扣'
          }
        },
        {
          label: '服务费折扣',
          prop: 'serviceFee',
          template: function (index, record) {
            if (record.serviceFeeType == 'fixed') {
              return record.serviceFee + '元'
            } else {
              return record.serviceFee + '%'
            }
          }
        },
        {
          label: '状态',
          prop: 'authStatusValue'
        }
      ],
      handles: {
        width: 280,
        btns: [
          {
            label: '详情',
            icon: 'el-icon-view',
            permission: 'valueadd.entrance.details',
            handle: resp => {
              this.$router.push({ path: './entranceDetail', query: { data: resp.id } })
            }
          },
          {
            label: '同步站点信息',
            permission: 'valueadd.entrance.frozen',
            url: '/evserv/evcs/v1/syncStation',
            method: 'post',
            isConfirm: true,
            confirmText: '确定进行此操作吗？',
            getLabel: function (record) {
              return record.disable ? '同步站点信息' : '同步站点信息'
            },
            getLabelStyle: record => {
              if (record.cz) {
                return record.disable ? 'color:#00FF00;' : 'color:red'
              } else {
                return 'color:#c0c4cc;cursor:not-allowed'
              }
            },
            getLabelDisabled: record => {
              return !record.cz
            },
            before: (index, record) => {
              return { operatorCode: record.operatorCode }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          },
          {
            label: '修改',
            icon: 'el-icon-edit',
            permission: 'valueadd.entrance.update',
            handle: resp => {
              this.$router.push({
                path: './reviseEntrance',
                query: {
                  id: resp.id,
                  name: resp.name,
                  operatorOrgId: resp.operatorOrgId,
                  type: resp.priceType,
                  electricity: resp.electricity,
                  serviceFee: resp.serviceFee
                }
              })
            }
          },
          {
            label: '启用',
            permission: 'valueadd.entrance.frozen',
            url: '/business/entrance/disable',
            method: 'get',
            isConfirm: true,
            confirmText: '确定进行此操作吗？',
            getLabel: function (record) {
              return record.disable ? '启用' : '终止'
            },
            getLabelStyle: record => {
              if (record.cz) {
                return record.disable ? 'color:#00FF00;' : 'color:red'
              } else {
                return 'color:#c0c4cc;cursor:not-allowed'
              }
            },
            getLabelDisabled: record => {
              return !record.cz
            },
            before: (index, record) => {
              return { id: record.id }
            },
            handle: () => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '方案名称',
          prop: 'name',
          placeholder: '请输入方案名称'
        },
        {
          label: '提供运营商',
          prop: 'operatorOrgId',
          type: 'select2',
          placeholder: '请输入提供运营商',
          data: [],
          remoteMethod: (val) => {
            this.getOperatorOrg(val)
          }
        },
        // {
        //   label: '电费优惠类型',
        //   prop: 'electricityType',
        //   type: 'select',
        //   placeholder: '请选择电费优惠类型',
        //   data: [
        //     {
        //       label: '电费折扣',
        //       value: 'discount'
        //     },
        //     {
        //       label: '电费一口价',
        //       value: 'fixed'
        //     }
        //   ]
        // },
        // {
        //   label: '服务费优惠类型',
        //   prop: 'serviceFeeType',
        //   type: 'select',
        //   placeholder: '请选择服务费优惠类型',
        //   data: [
        //     {
        //       label: '服务费折扣',
        //       value: 'discount'
        //     },
        //     {
        //       label: '服务费一口价',
        //       value: 'fixed'
        //     }
        //   ]
        // },
        {
          label: '状态',
          prop: 'status',
          type: 'select',
          placeholder: '请选择状态',
          data: [
            {
              label: '未开始',
              value: 0
            },
            {
              label: '进行中',
              value: 1
            },
            {
              label: '已结束（自动到期）',
              value: 2
            },
            {
              label: '已结束（手动停用）',
              value: 3
            }
          ]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'valueadd.entrance.add',
          type: 'primary',
          handle: resp => {
            this.$router.push({ path: './addEntrance' })
          }
        }
      ]

    }
  },
  computed: {},
  mounted() { },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() {
    this.getOperatorOrg()
  }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { },
  methods: {
    getOperatorOrg(val) {
      const data = {
        operatorName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/entrance/getOperatorOrg',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp) {
            this.query[1].data = resp
          }
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped></style>



// WEBPACK FOOTER //
// src/views/flowScheme/entranceScheme.vue